import { AfterContentInit, Component, ContentChildren, Input, QueryList, TemplateRef } from '@angular/core';
import {
	NzTableFilterFn,
	NzTableFilterList,
	NzTableModule,
	NzTableSortFn,
	NzTableSortOrder
} from 'ng-zorro-antd/table';
import { ZorroModule } from '../../../../modules/zorro.module';
import { CommonModule } from '@angular/common';
import { HeaderColumn } from './header-column';
import { RowColumn } from './row-column';

export interface Column {
	key: string;
	name: string;
	sortOrder?: NzTableSortOrder | null;
	sortFn?: NzTableSortFn<any> | null;
	filterOptions?: NzTableFilterList;
	filterFn?: NzTableFilterFn<any> | null;
	filterMultiple?: boolean;
	sortDirections?: NzTableSortOrder[];
}

@Component({
	selector: 'app-reporting-table',
	standalone: true,
	imports: [
		CommonModule,
		ZorroModule,
		NzTableModule,
	],
	templateUrl: './reporting-table.html',
	styleUrl: './reporting-table.scss',
})
export class ReportingTable implements AfterContentInit {
	@Input('rows') public rows: object[] = [];
	@Input('columns') public columns: Column[] = [];
	@Input('loading') public loading: boolean = false;

	@ContentChildren(HeaderColumn) headerDirectives!: QueryList<HeaderColumn>;
	@ContentChildren(RowColumn) cellDirectives!: QueryList<RowColumn>;

	public headerMap = new Map<string, TemplateRef<any>>();
	public cellMap = new Map<string, TemplateRef<any>>();

	ngAfterContentInit(): void {
		this.headerDirectives.forEach(dir => this.headerMap.set(dir.key, dir.template));
		this.cellDirectives.forEach(dir => this.cellMap.set(dir.key, dir.template));
	}
}